import { InputAdornment, TextField, Tooltip, Box } from "@mui/material";
import React, { useState } from "react";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";
import ModalToShowAnExerciseInfo from "../Workout/components/ModalToShowAnExerciseInfo";
import CustomComplateFeild from "./CustomComplateFeild";
import { formatWithLeadingZeros } from "src/utils/constant";

const RepsForTimeExercisesUI = ({
  addArray,
  setaddArray,
  memberId,
  mainindex,
  message,
  isPersonal,
  isSidebar,
  isWithHistoryAndBigScreen,
}) => {
  const [openSingleExerciseInfo, setOpenSingleExerciseInfo] = useState(false);
  const [singleExerciseInfo, setSingleExerciseInfo] = useState("");
  const [repsRound, setRepsRound] = useState(
    addArray[mainindex]["reps_round"] || [1]
  );

  const handleArrowSuperSet = (value, index, exerIndex) => {
    const list = [...addArray];
    list[mainindex]["emomSets"][index][exerIndex]["open"] = value;
    setaddArray(list);
  };

  const handleClickOpen = async (exercise) => {
    setSingleExerciseInfo(exercise);
    setOpenSingleExerciseInfo(true);
  };

  return (
    <div className="my-2">
      {openSingleExerciseInfo && (
        <ModalToShowAnExerciseInfo
          open={openSingleExerciseInfo}
          setOpen={setOpenSingleExerciseInfo}
          Id={singleExerciseInfo}
        />
      )}
      <div className="characters mt-2">
        <div
          style={{ position: "relative" }}
          className="workout-Superset-card my-1"
        >
          <Box>
            <div className="row mb-3">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="d-flex align-items-center flex-wrap">
                  <div>Reps</div>
                  {repsRound.map((item, index) => {
                    return (
                      <div>
                        <Tooltip touch="on" placement="top" title={message}>
                          <TextField
                            id="outlined-basic"
                            size="small"
                            variant="outlined"
                            placeholder=""
                            type="number"
                            value={item}
                            name="total_rounds"
                            InputLabelProps={{
                              className: "textfiels-input-label",
                              shrink: true,
                              style: { fontSize: "14px" },
                            }}
                            InputProps={{
                              className: "textfiels-input-value",
                              style: { fontSize: "13px", padding: "0" },
                              readOnly: true,
                            }}
                            sx={{
                              mx: 1,
                              borderRadius: "5px",
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                              fontSize: "13px",
                              "& input": {
                                padding: "5px 5px",
                                textAlign: "center",
                              },
                              width: "33px",
                            }}
                          />{" "}
                        </Tooltip>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className={`col-sm-12 col-md-7 col-lg-7 order-3 order-md-2`}>
                <div className="d-flex align-items-center justify-content-end text-center text-md-start  my-2">
                  Reps For Time
                </div>
              </div>
              <div className="col-sm-12 col-md-5 col-lg-5  cross-icon order-1 order-md-3 d-flex justify-content-end">
                <Tooltip title="Remove Exercise">
                  <RemoveCircleOutlineIcon className="diary-icon-remove" />
                </Tooltip>
                <Tooltip title="Add Exercise">
                  <AddCircleOutlineIcon className="diary-icon-add" />
                </Tooltip>
                <CustomPopoverSection menu={[]} data={mainindex} />
              </div>
            </div>
            {addArray[mainindex].emomSets.length > 0 &&
              addArray[mainindex].emomSets.map((item, index) => {
                return (
                  <div className=" my-2 ">
                    <div className="d-flex justify-content-between align-items-center ">
                      <div className="fs-5">Movements</div>
                    </div>
                    {item.length > 0 &&
                      item.map((exerData, exerIndex) => {
                        return (
                          <CustomComplateFeild
                            exerData={exerData}
                            message={message}
                            handleArrowSuperSet={handleArrowSuperSet}
                            handleClickOpen={handleClickOpen}
                            isSidebar={isSidebar}
                            isWithHistoryAndBigScreen={
                              isWithHistoryAndBigScreen
                            }
                            memberId={memberId}
                            index={index}
                            exerIndex={exerIndex}
                          />
                        );
                      })}
                  </div>
                );
              })}
            {isPersonal && (
              <Tooltip touch="on" placement="top" title={message}>
                <div className="mx-4 d-flex align-items-center justify-content-start flex-wrap mt-3 ">
                  <div className="d-flex align-items-center justify-content-start mt-3 pe-3 ">
                    <div style={{ whiteSpace: "nowrap" }}>Reps</div>
                    {repsRound.map((item, index) => {
                      return (
                        <div className={``}>
                          <TextField
                            id="outlined-basic"
                            size="small"
                            variant="outlined"
                            placeholder=""
                            type="number"
                            value={item}
                            name="total_rounds"
                            InputLabelProps={{
                              className: "textfiels-input-label",
                              shrink: true,
                              style: { fontSize: "14px" },
                            }}
                            InputProps={{
                              className: "textfiels-input-value",
                              style: { fontSize: "13px", padding: "0" },
                              readOnly: true,
                            }}
                            sx={{
                              mx: 1,
                              borderRadius: "5px",
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                              fontSize: "13px",
                              "& input": {
                                padding: "5px 5px",
                                textAlign: "center",
                              },
                              width: "33px",
                            }}
                          />{" "}
                        </div>
                      );
                    })}
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-7 d-flex align-items-center justify-content-start mt-3 ">
                      <div style={{ whiteSpace: "nowrap" }} className="pe-3">
                        Total Time Completed
                      </div>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        label="Total Time"
                        InputLabelProps={{
                          className: "textfiels-input-label",
                          shrink: true,
                          style: {
                            fontSize: "14px",
                          },
                        }}
                        InputProps={{
                          className: "textfiels-input-value",
                          style: {
                            fontSize: "13px",
                            paddingLeft: "0px",
                            paddingRight: "0px",
                            justifyContent: "center",
                          },
                          readOnly: true,
                          endAdornment: (
                            <InputAdornment
                              position="end"
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <TextField
                                id="outlined-basic-minutes"
                                type="number"
                                size="small"
                                placeholder="Min"
                                value={formatWithLeadingZeros(
                                  Math.floor(
                                    addArray[mainindex].time_interval / 60
                                  )
                                )}
                                InputProps={{
                                  className: "textfiels-input-value",
                                  style: {
                                    fontSize: "14px",
                                  },
                                  readOnly: true,
                                }}
                                sx={{
                                  "& fieldset": {
                                    border: "none",
                                  },
                                  "& input": {
                                    textAlign: "center",
                                    padding: "0px",
                                  },
                                  width: "100%",
                                }}
                              />
                              <div className="fs-6 fw-semibold ms-1 ">:</div>
                              <TextField
                                id="outlined-basic-seconds"
                                type="number"
                                size="small"
                                placeholder="Sec"
                                value={formatWithLeadingZeros(
                                  addArray[mainindex].time_interval % 60
                                )}
                                InputProps={{
                                  className: "textfiels-input-value",
                                  style: {
                                    fontSize: "14px",
                                  },
                                  readOnly: true,
                                }}
                                sx={{
                                  "& fieldset": {
                                    border: "none",
                                  },
                                  "& input": {
                                    textAlign: "center",
                                    padding: "0px",
                                  },
                                  width: "100%",
                                }}
                              />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          borderRadius: "5px",
                          fontSize: "13px",
                          "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                            {
                              width: "0px !important",
                              padding: "9px 0px !important",
                            },
                          "& .css-1nuss9t": {
                            width: "0px !important",
                            padding: "9px 0px !important",
                          },
                          width: "100%",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Tooltip>
            )}
          </Box>
        </div>
      </div>
    </div>
  );
};
export default RepsForTimeExercisesUI;
